"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
__export(require('./lib/tag-input.module'));
__export(require('./lib/components/tag-input/tag-input.component'));
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular2-tag-input/dist/index.js
// module id = 184
// module chunks = 1